import useGameMediaDownload from './useGameMediaDownload';

const useGameImages = () => {
  const { handleDownload, isLoading, progress } = useGameMediaDownload('images');

  return {
    downloadImages: handleDownload,
    isLoading,
    progress,
  };
};

export default useGameImages;
